import { Box, Flex, useBreakpoint } from '@chakra-ui/react'

import GenericPlaceholder from 'src/assets/image/PlaceholderGenericSVG'
import AudioPlayerInline from 'src/components/widgets/AudioPlayerInline/AudioPlayerInline'
import ExpandableText from 'src/components/widgets/ExpandableText/ExpandableText'
import ItListImage from 'src/components/widgets/ItListImage/ItListImage'
import { ItListItemAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'
import { BrandColor } from 'src/types'

import CardWrapper from '../../CardWrapper/CardWrapper'

import useImageCard from './useImageCard'

export type ImageCardProps = {
  profilePictureUrl: string
  brandColor: BrandColor
  imageUrl?: string
  voiceTipUrl: string
  hasVoiceTip: boolean
  title?: string
  description?: string
  trackingData: ItListItemAnalyticsProps
  itemId: number
  isPreview: boolean
}

const ImageCard = ({
  brandColor,
  profilePictureUrl,
  imageUrl,
  title,
  voiceTipUrl,
  hasVoiceTip,
  trackingData,
  itemId,
  isPreview,
  description,
}: ImageCardProps) => {
  const size = useBreakpoint()

  const { openImage } = useImageCard(imageUrl, title)
  if (!size) return null
  const isSm = isPreview || size === 'sm'
  return (
    <CardWrapper itemId={itemId} brandColor={brandColor}>
      <>
        <Box w="100%" position="relative">
          <Box w="100%" position="relative" overflow="hidden">
            {imageUrl && (
              <ItListImage
                aspectRatio={isSm ? 'auto' : 16 / 9}
                htmlWidth={552}
                width="100%"
                objectFit="cover"
                objectPosition="top center"
                src={imageUrl}
                onClick={openImage}
                alt={title || 'ItList image item'}
                data-testid="itemCard-image-image"
              />
            )}
            {!imageUrl && <GenericPlaceholder width="100%" />}
          </Box>
        </Box>
        {(hasVoiceTip || title || description) && (
          <Flex p={4} gap={2} direction="column">
            {hasVoiceTip && (
              <Box>
                <AudioPlayerInline
                  mediaUrl={voiceTipUrl}
                  title={title}
                  pictureUrl={profilePictureUrl}
                  brandColor={brandColor}
                  trackingData={trackingData}
                />
              </Box>
            )}
            {title && (
              <Box
                className="body-small-emphasis"
                data-testid="itemCard-image-label"
              >
                {title}
              </Box>
            )}
            {description && (
              <ExpandableText
                className="body-extra-small"
                data-testid="itemCard-image-label"
                text={description}
              />
            )}
          </Flex>
        )}
      </>
    </CardWrapper>
  )
}

export default ImageCard
